export default __webpack_public_path__ + "static/media/shop-categories-img04.d7353463.jpg";